export const status = [
  { label: "Activated", id: "Active" },
  { label: "Deactivated", id: "Deactive" },
];

export const userRoles = [
  { label: "Admin", id: "admin" },
  { label: "Buyer", id: "buyer" },
];